import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/axios'
import { API_ROUTES } from '@/constants/routes'
import { useAuthStore } from '@/stores/useAuthStore'

export interface PrintSize {
    id: number
    name: string
    slug: string
    width_mm: number
    height_mm: number
    is_active: boolean
    sort_order: number
    allow_half_millar: boolean
}

const KEYS = {
    all: ['print-sizes'] as const,
    list: () => [...KEYS.all, 'list'] as const,
}

export function usePrintSizes() {
    const { isLogged } = useAuthStore()
    return useQuery({
        queryKey: KEYS.list(),
        queryFn: async () => {
            const { data } = await api.get<{ results: PrintSize[] } | PrintSize[]>(API_ROUTES.printSizes)
            return Array.isArray(data) ? data : data.results
        },
        enabled: isLogged,
        staleTime: 5 * 60 * 1000,
    })
}
